import { createContext, useContext, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { ImpactAnalysisModal } from "@/components/impact-analysis/ImpactAnalysisModal";

type ImpactAnalysisModalContextType = {
  showImpactAnalysisModal: () => void;
};

const ImpactAnalysisModalContext =
  createContext<ImpactAnalysisModalContextType | null>(null);

export function useImpactAnalysisModal() {
  const context = useContext(ImpactAnalysisModalContext);
  if (!context) {
    throw new Error(
      "useImpactAnalysisModal must be used within ImpactAnalysisModalProvider"
    );
  }
  return context;
}

export function ImpactAnalysisModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const showImpactAnalysisModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <ImpactAnalysisModalContext.Provider value={{ showImpactAnalysisModal }}>
      {children}
      <ImpactAnalysisModal
        isOpen={isOpen}
        onClose={closeModal}
        onChooseManual={() => {
          closeModal();
          navigate("/analiza-efect-perturbator");
        }}
        onChooseUpload={() => {
          closeModal();
          navigate("/onboarding/efectul-perturbator");
        }}
      />
    </ImpactAnalysisModalContext.Provider>
  );
}
